<script setup lang="ts">
// Status de Saque do Minha Conta V2 (ENG-362). Rota sem frame no Figma:
// mesma API da página antiga (pages/user/wallet/last-withdraw.vue →
// useWalletStore.getTransactions) via lista compartilhada, filtrando só
// saques — mesmo type 'withdraw' já usado no ScreenTransactionsHistory.
const FILTERS = [{ key: 'withdraw', label: 'Saques' }];
</script>

<template>
  <UserV2HistoryTransactionsList :filters="FILTERS" />
</template>
